import { EmailTabState, EmailTabViewModel } from './EmailView/types';
import { PasswordTabState, PasswordTabViewModel } from './PasswordView/types';

export enum UserSettingsTabs {
  PROFILE = 'profile',
  EMAIL = 'email-settings',
  API = 'api',
  APPLICATIONS = 'applications',
  PASSWORD = 'password-settings',
  NOTIFICATIONS = 'notifications',
}

export type UserSettingsState = {
  userSettingsSelectedTab: UserSettingsTabs;
  currentUserHasPlainLogin: boolean;
  emailTabState: EmailTabState;
  passwordTabState: PasswordTabState;
};

export type UserSettingsViewModel = {
  userSettingsSelectedTab: UserSettingsTabs;
  showChangeEmailAndPassword: boolean;
  emailTabViewModel: EmailTabViewModel;
  passwordTabViewModel: PasswordTabViewModel;
};
